var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-6 col-xxxl-3 mb-xxl-3 px-1 px-xxl-3"},[_c('div',{staticClass:"pt-2 h-100"},[_c('button',{staticClass:"btn btn-fade btn-block h-100 p-0 p-xxl-1 p-xxxl-2",class:{
        'btn-light': _vm.isActiveCampus,
        'btn-dark': !_vm.isActiveCampus,
      },on:{"click":function($event){return _vm.setCampus(_vm.campus)}}},[_c('div',{staticClass:"small"},[_vm._v(_vm._s(_vm.campus))]),_c('img',{staticClass:"campus-icon",class:{ invertColor: _vm.isActiveCampus },attrs:{"src":_vm.campusIconSRC}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }